import { Fragment } from 'react'
import { GetStaticProps, GetStaticPropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

import { usePageTitle } from '~/utils/tags'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import Metatags from '~/components/Metadata/Metatags'
import Dashboard from '~/dashboard/pages/Dashboard'
import { AppLanguage } from '~/types/locale'
import sanity from '~/shared/sanity/sanity-client'
import { DashboardProps } from '~/dashboard/types/dashboard.types'

const DashboardPage = (props: DashboardProps): React.ReactElement => {
  const { t } = useTranslation('dashboard')
  const pageTitle = usePageTitle(t('title'))
  return (
    <Fragment>
      <Metatags metaDescription={t('metaDescription')} noindex title={pageTitle} />

      <Dashboard homMethodsData={props.homMethodsData} />
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext<{ locale: AppLanguage }>) => {
  const groqQuery = `*[_type == "homMethod" && language==$language][0]`
  const homMethodsData = await sanity.fetch(groqQuery, { language: locale })

  return {
    props: {
      homMethodsData,
      ...(await serverSideTranslations(locale as string, [
        ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
        ...COMMON_TRANSLATION_MODULE_NAMES,
        'tutorOnDemand',
        'sessionStatus',
        'studentPanel',
        'highscore',
        'dashboard',
        'leaderboard',
        'avatar',
        'home',
        'authenticate',
        'statistics',
        'fields',
      ])),
    },
    revalidate: process.env.ENVIRONMENT === 'staging' ? 60 : false,
  }
}

export default DashboardPage
